import type { GatewayAssetOut } from "kubb";
import AssetRegisterList from "pages/assetRegister/AssetRegisterListPage/AssetRegisterList";
import type React from "react";
import RoutedTabGroupInterface from "../../../../components/TabGroup/RoutedTabGroupInterface";
import type { Tab } from "../../../../components/TabGroup/model";
import { Heading } from "../../../../components/Theme/heading";
import EventList from "../../../../containers/event/EventList";
import AssetPositionAssetList from "../../assetPositions/assetPositionAssetLinks/AssetPositionAssetList";
import AssetConfigurationPage from "../AssetConfigurationPage";
import MeterTimeSeriesCharts from "../meters/MeterTimeSeriesCharts";
import AssetInstructionsTab from "./AssetInstructionsTab";
import GatewayConfigurationTab from "./GatewayConfigurationTab";
import GatewayFilelist from "./GatewayFileList/GatewayFilelist";
import GatewayJobTab from "./GatewayJobTab";
import StreamingGatewayData from "./data/StreamingGatewayData";

interface Props {
  gateway: GatewayAssetOut;
  refresh?: () => any;
}

export default function GatewayHomepage(props: Props): React.ReactElement {
  const asset_id = props.gateway.asset_id;

  const tabs: (Tab | undefined)[] = [
    {
      tabName: "Statistics",
      tabContent: <MeterTimeSeriesCharts device={props.gateway} />,
      tabPath: "statistics",
      userTypes: "superadmin",
    },
    {
      tabName: "Devices",
      tabContent: (
        <>
          <AssetRegisterList
            company_id={props.gateway.company_id}
            params={{
              parent_asset_position_id: props.gateway.asset_position_id,
            }}
            createAssetTags={false}
          />
        </>
      ),
      tabPath: "devices",
      keepSearchString: false,
    },
    props.gateway.manufacturer === "elvaco" && props.gateway.model === "Edge"
      ? undefined
      : {
          tabName: "Files",
          tabContent: <GatewayFilelist asset={props.gateway} />,
          tabPath: "files",
          keepSearchString: false,
        },
    props.gateway.manufacturer === "lansen" ||
    (props.gateway.manufacturer === "elvaco" && props.gateway.model === "Edge")
      ? {
          tabName: "LiveData",
          tabContent: <StreamingGatewayData gateway={props.gateway} />,
          tabPath: "live_data",
        }
      : undefined,
    {
      tabName: "Events",
      tabContent: (
        <EventList asset_id={asset_id} company_id={props.gateway.company_id} />
      ),
      tabPath: "events",
      keepSearchString: false,
    },
    {
      tabName: "Configuration",
      tabContent: (
        <GatewayConfigurationTab
          gateway={props.gateway}
          refresh={props.refresh}
        />
      ),
      tabPath: "configuration",
      keepSearchString: false,
    },
    {
      tabName: "Instructions",
      tabContent: <AssetInstructionsTab asset={props.gateway} />,
      tabPath: "instructions",
      keepSearchString: false,
    },
    {
      tabName: "Configuration (detailed)",
      tabContent: (
        <AssetConfigurationPage
          asset_id={props.gateway.asset_id}
          serial_number={props.gateway.serial_number}
        />
      ),
      tabPath: "detailed",
      keepSearchString: false,
      userTypes: "superadmin",
    },
    {
      tabName: "Asset Position History",
      tabPath: "link",
      tabContent: (
        <>
          <Heading>Asset Position Asset History</Heading>
          <AssetPositionAssetList
            asset_id={asset_id}
            view={"assetPosition"}
            company_id={props.gateway.company_id}
            scheme_id={props.gateway.scheme_id}
          />
        </>
      ),
      userTypes: "superadmin",
      keepSearchString: false,
    },
    {
      tabName: "Jobs",
      tabContent: <GatewayJobTab gateway={props.gateway} />,
      tabPath: "job",
      keepSearchString: false,
    },
  ];

  return (
    <RoutedTabGroupInterface
      tabs={tabs}
      topLevelPath={`/admin/asset_register/asset/${asset_id}`}
    />
  );
}
